import { create } from "zustand";

interface XpState {
  totalXp: number;
  weeklyXp: number;
  currentStreak: number;
  longestStreak: number;
  streakFreezeAvailable: boolean;
  reviewsDue: number;
  badges: string[];
  loaded: boolean;
}

interface XpActions {
  setXp: (data: Partial<XpState>) => void;
  addBadges: (keys: string[]) => void;
  decrementReviews: () => void;
}

export const useXpStore = create<XpState & XpActions>((set) => ({
  totalXp: 0,
  weeklyXp: 0,
  currentStreak: 0,
  longestStreak: 0,
  streakFreezeAvailable: false,
  reviewsDue: 0,
  badges: [],
  loaded: false,

  setXp: (data) => set((s) => ({ ...s, ...data, loaded: true })),
  addBadges: (keys) =>
    set((s) => ({ badges: [...new Set([...s.badges, ...keys])] })),
  decrementReviews: () =>
    set((s) => ({ reviewsDue: Math.max(0, s.reviewsDue - 1) })),
}));
